<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                (click)="addTaxCategorySlab(0)" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Tax Category Slab':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Tax Cateegory Slab Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th>Tax Category Name</th>
                        <!-- <th style="width: 20px;">Category</th> -->
                        <th style="width: 20px;">Slab From</th>
                        <th style="width: 20px;">Slab To</th>
                        <th style="width: 20px;">Financial Year Start</th>
                        <th style="width: 20px;">Financial Year End</th>
                        <th style="width: 20px;">From Age</th>
                        <th style="width: 20px;">To Age</th>
                        <th style="width: 20px;">Regime</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i
                                    (click)="addTaxCategorySlab(TableData['ESS_TaxSlabMasterID'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td>{{TableData['TaxCategoryName']}}</td>
                        <!-- <td style="width: 20px;">{{TableData['Category']}}</td> -->
                        <td style="width: 20px;">{{TableData['SlabFrom']}}</td>
                        <td style="width: 20px;">{{TableData['SlabTo']}}</td>
                        <td style="width: 20px;">{{TableData['FinancialYearStart']| date: 'dd MMM yyyy'}}</td>
                        <td style="width: 20px;">{{TableData['FinancialYearEnd']| date: 'dd MMM yyyy'}}</td>
                        <td style="width: 20px;">{{TableData['FromAge']}}</td>
                        <td style="width: 20px;">{{TableData['ToAge']}}</td>
                        <td style="width: 20px;">{{TableData['IsNewRegime']?'New':'Old'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" 
                    class="btn btn-primary mx-1" [disabled]="isDisabled"
                    (click)="ExcelDump()"><i *ngIf="!isDisabled" class="bi bi-download me-1"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</div>